var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220.566,
    height: 307.16,
    viewBox: "0 0 220.566 307.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.52,60.12C201.33,22.53,151.28-.06,110.74,0,70.56.06,21.07,24.46,6.91,60.12-7.97,97.57,2.07,139.31,28.46,174.51Q53.255,207.6,78.3,240.55h64.84c16.76-21.91,33.27-44.33,49.85-66.04,25.96-33.98,34.64-77.06,21.53-114.39Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 2.682,
    x2: 0.5,
    y2: -1.231,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616083"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19710 -6589)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.19,307.16h-9.9a11.67,11.67,0,0,1-11.67-11.7l.03-13.83h33.19l.02,13.83a11.674,11.674,0,0,1-11.67,11.69Z",
    transform: "translate(19710.002 6589)",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.86,292.45l-.02-10.82H93.65l-.03,10.82Z",
    transform: "translate(19710.002 6589)",
    fill: "#2172ff",
    opacity: 0.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.83,283.88H91.65l.02-4.49h37.15Z",
    transform: "translate(19710.002 6589)",
    fill: "#e7387e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19710.002 6589)",
    clipPath: "url(#a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 268.68,
    height: 268.68,
    transform: "translate(-15 -22.99)",
    fill: "#474747"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 268.68,
    height: 65.43,
    transform: "translate(-15 -22.99)",
    fill: "#474747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.7,31.53C175.34,20.07,163.05,8.56,151.77-4a103.236,103.236,0,0,1,.9,36.68,388.955,388.955,0,0,1-23-34.33c-4.21,14.13-11.32,26.14-19.43,38.31C102.02,24.57,94.73,12.51,89.52-1.21,82.28,11.44,74.29,23.48,65.92,35.4A183.8,183.8,0,0,1,60.68-1.29C50.9,12.73,39.26,25.24,27.43,37.52c-1.21-13.77-.64-20.38-2.79-28.51C16.44,21.64,8.16,34.21.11,46.94A262.893,262.893,0,0,0,8.43,80.68C21.22,67.73,33.88,54.64,45.57,40.67A137.685,137.685,0,0,0,57.2,79.01Q71.66,60.305,85.39,41.1c6.66,13.8,15.46,25.85,24.85,37.88a206.579,206.579,0,0,0,24.59-39q13.89,19.17,28.36,37.88c4.77-13.68,8.17-26.85,8.38-41.46,12.91,14.21,26.17,28.03,39.64,41.71,2.97-12.48,4.02-25.27,4.21-38.07-9.74-12.67-19.57-24.98-31.95-35.21.87,4.8,3.03,11.9,4.25,26.7Z",
    fill: "#474747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.73,69.75c-13.49-13.49-26.87-27.07-39.65-41.24a113.952,113.952,0,0,1-6.41,41.29c-9.48-12.32-18.75-24.76-27.75-37.44a193.836,193.836,0,0,1-23.68,39.13C101.03,59.44,92.5,47.38,86.15,33.52,77.22,46.36,68.01,58.9,58.49,71.31A139.827,139.827,0,0,1,48.34,32.98C36.78,47.06,24.11,60.15,11.29,73.07A334.026,334.026,0,0,1,4.61,39.78C-3.75,53.21-11.54,66.66-18.58,80.83A154.418,154.418,0,0,0,.46,114.32C11.69,101.85,23.05,89.49,34.04,76.8c4.82,13.49,11.92,25.3,19.82,37.16,9.43-12.54,18.95-25.01,28.44-37.51a437.831,437.831,0,0,0,27.95,37.35,370.647,370.647,0,0,0,28.13-37.88q14.37,18.975,28.64,38.02c8.1-12.45,14.95-24.72,18.74-39.22q17.385,19.92,35.13,39.53a119.978,119.978,0,0,0,17.32-36.78,260.516,260.516,0,0,0-28.43-44.9c.35,12.43.02,24.88-2.05,37.17Z",
    fill: "#2172ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207.89,157.26c-2.75-11.83-8.6-21.83-14.66-32.19-10.99,12.3-22.5,24.11-33.46,36.43-5.07-13.05-12.48-24.5-20.34-36-9.86,12.38-19.67,24.77-29.19,37.41-9.64-12.54-19.44-24.95-29.18-37.41-7.87,11.44-15.28,22.76-19.82,36-10.8-12.42-22.32-24.18-33.3-36.43-5.71,10.35-11.21,20.22-12.62,32.19C.66,146.3-14.37,135.78-28.54,124.2c2.72,13.41,11.15,23.56,19.57,33.85,17.98,11.01,35.72,22.36,51.78,36.11-2.12-9.32-3.02-20.36-1.51-29.82,12.23,11.66,24,24.13,33.56,38.12a91.646,91.646,0,0,1,10-34.98c8.98,12.3,17.36,24.82,25.4,37.75,7.81-13.08,16.13-25.49,25.18-37.75a110.847,110.847,0,0,1,11.44,34.98,293.953,293.953,0,0,1,34.22-38.12,96.089,96.089,0,0,1,2.16,29.82c15.41-13.5,32.48-25.17,49.75-36.11,7.86-9.9,14.95-21.2,17.14-33.85-13.61,11.58-28.14,22.11-42.25,33.06Z",
    fill: "#e7387e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.94,186.01a87.361,87.361,0,0,0-4.17-30.35,361.556,361.556,0,0,0-34.93,37.75,114.153,114.153,0,0,0-13.2-35.21c-9.37,12.25-18.14,24.65-26.4,37.67-8.48-12.88-17.3-25.38-26.61-37.67a94.248,94.248,0,0,0-11.89,35.21c-10.15-13.71-22.19-26.02-34.53-37.75-2.46,9.34-2.51,20.87-.68,30.35C20.24,172.83,2.6,161.6-15.18,150.57c9.98,11.89,20.7,22.84,31.64,33.85,16.89,11.44,31.83,23.25,45.38,38.48-.51-9.97-2.88-15.69-4.04-27.98a192.191,192.191,0,0,1,26.46,39.44c.07-11.98,2.48-22.69,5.56-34.19,7.3,12.44,13.94,25.12,20.42,38.01a354.234,354.234,0,0,1,20.19-38.01c3.38,11.42,6.17,22.26,7.01,34.19A179.38,179.38,0,0,1,166,194.92c.3,12.29-1.06,18.01-.69,27.98,13.72-14.81,28.5-26.87,44.97-38.48,9.81-10.95,19.77-21.77,28.19-33.85-17.04,11.19-33.57,22.73-49.52,35.44Z",
    fill: "#2172ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17,103.59q-18.915-20.325-37.39-41.05c-2.54,14.7-8.24,27.4-15.31,40.4Q151.9,83.785,137.42,64.56a287,287,0,0,1-27.18,38.27A344.7,344.7,0,0,1,83.15,65.32q-14.28,19.02-28.8,37.84A142.209,142.209,0,0,1,37.31,65.44C25.86,78.67,13.88,91.43,1.86,104.14A159.4,159.4,0,0,1-13.3,70.19c-6.3,12.74-12.35,25.35-14.92,39.47,9.99,12.37,22.5,22.12,34.73,32.12,4.95-12.69,12.99-22.96,21.45-33.45,8.17,13.08,18.83,24.41,28.92,35.99,6.49-13.15,15.31-24.68,24.05-36.37q14.445,18.78,29.3,37.21c9.86-12.39,19.75-24.75,29.5-37.23,8.72,11.73,17.4,23.37,24.15,36.39,10.35-11.75,20.49-23.14,29.17-36.19,8.64,10.63,16.8,21.14,22.6,33.65,11.93-10.06,24.53-19.84,33.97-32.42-3.18-15.78-10.31-29.75-17.76-43.85-2.44,13.22-6.39,26.18-12.69,38.09Z",
    fill: "#e7387e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.49,125.37c-9.57-12.88-20.6-24.73-31.01-36.92-5.36,14.16-13.62,25.85-22.92,37.64-8.81-12.66-18.07-24.95-27.38-37.25-9.06,13.03-18.91,25.21-28.95,37.5-9.93-12.19-19.65-24.37-28.71-37.22-9.3,12.2-18.55,24.39-27.33,36.98-8.91-11.56-17.15-23.13-23.26-36.46C20.82,101.37,10.05,112.78,1,125.37c-9.57-10.1-17.78-20.43-24.56-32.63-4.29,11.21-7.43,24.19-3.89,36.06,15.2,11.4,30.86,22.17,46.14,33.48.54-11.71,5.18-21.5,10.12-31.87,11.46,12.13,23.23,23.99,34.09,36.66,3.92-13.19,10.87-24.45,18.35-35.86,9.77,12.41,19.48,24.84,28.98,37.46,9.36-12.72,19.06-25.12,28.92-37.46,7.51,11.46,14.5,22.84,19.03,35.86,11.06-12.55,22.76-24.48,34.21-36.66,5.39,10.33,10.51,20.24,12.5,31.87,14.67-11.28,29.72-22.06,44.28-33.48,3.52-13.2-.88-25.54-5.06-37.95-5.83,13.35-13.73,23.97-23.63,34.52Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,224.02q6.27,8.28,12.58,16.53h64.84q6.285-8.22,12.54-16.53H65.72Z",
    fill: "#b2c1ce",
    opacity: 0.55,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6-2.47c5.92,11.55,7.76,25.49,8.93,38.22,6.44,69.76-6.16,139.35-11.19,208.9,2.07,0,2.68,1.47,4.74,1.47,9.31-38.24,18.7-79.92,26.55-115.5,7.23-32.79,19.18-112.5-18.09-133.08H121.6Z",
    fill: "#b2c1ce",
    opacity: 0.55,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.58-4.58c8.68,10.4,20.15,25.33,22.43,37.61,13.28,71.55-24.69,141.18-37.44,213.27,2,.13-1.21.22.7.46,9.94-39.99,39-76.59,52.92-115.22C203.37,94.97,211.13,25.35,162.04-2.99a42.391,42.391,0,0,0-10.46-1.6Z",
    fill: "#b2c1ce",
    opacity: 0.55,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63,16.55A86.326,86.326,0,0,1,214.6,56.71c2.9,24.86.65,47.31-6.49,71.05-11.56,38.47-39.45,74.24-57.63,112.62,1.63.44,2.41.68,3.94,1.19,29.02-54.58,150.45-168.45,57.35-220.53-6.75-2.59-9.86-3.76-13.14-4.5Z",
    fill: "#b2c1ce",
    opacity: 0.55,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.38-2.47c-5.92,11.55-7.76,25.49-8.93,38.22-6.44,69.76,6.16,139.35,11.19,208.9-2.07,0-2.68,1.47-4.74,1.47-9.31-38.24-18.7-79.92-26.55-115.5C63.11,97.82,51.16,18.11,88.43-2.47H99.37Z",
    fill: "#b2c1ce",
    opacity: 0.55,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.39-4.58C60.71,5.82,49.24,20.75,46.96,33.03,33.68,104.58,71.65,174.21,84.4,246.3c-2,.13,1.21.22-.7.46-9.94-39.99-39-76.59-52.92-115.22C17.6,94.97,9.84,25.35,58.93-2.98A42.391,42.391,0,0,1,69.39-4.58Z",
    fill: "#b2c1ce",
    opacity: 0.55,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.34,16.55A86.325,86.325,0,0,0,6.37,56.71c-2.9,24.86-.65,47.31,6.49,71.05C24.42,166.23,52.31,202,70.49,240.38c-1.63.44-2.41.68-3.94,1.19C37.54,187-83.89,73.13,9.2,21.05,15.95,18.46,19.06,17.29,22.34,16.55Z",
    fill: "#b2c1ce",
    opacity: 0.55,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.344,281.121a269.343,269.343,0,0,1-8.019-29.6l.49-.1a268.8,268.8,0,0,0,8,29.539Z",
    transform: "translate(19710.002 6589)",
    fill: "#16546d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.861,281.135l-.463-.19a236.864,236.864,0,0,0,9.528-29.534l.486.118A237.407,237.407,0,0,1,114.861,281.135Z",
    transform: "translate(19710.002 6589)",
    fill: "#16546d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2,281.168c-.021-.035-2.126-3.582-4.872-8.979a177.148,177.148,0,0,1-8.979-20.635l.472-.166a176.643,176.643,0,0,0,8.953,20.575c2.738,5.383,4.835,8.915,4.856,8.951Z",
    transform: "translate(19710.002 6589)",
    fill: "#16546d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.011,281.174l-.423-.267c.022-.035,2.254-3.571,5.167-8.954a172.057,172.057,0,0,0,9.53-20.57l.468.176a172.569,172.569,0,0,1-9.56,20.636C127.272,277.592,125.034,281.138,125.011,281.174Z",
    transform: "translate(19710.002 6589)",
    fill: "#16546d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.37,254.86H85.24a7.625,7.625,0,0,1-7.62-7.68c.02-2.49.04-4.94.07-8.25h65.23c.03,3.32.04,5.77.06,8.26a7.616,7.616,0,0,1-7.62,7.67Z",
    transform: "translate(19710.002 6589)",
    fill: "#e7443d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.37,254.86H85.24a7.625,7.625,0,0,1-7.62-7.68c.02-2.49.04-4.94.07-8.25h65.23c.03,3.32.04,5.77.06,8.26a7.616,7.616,0,0,1-7.62,7.67Z",
    transform: "translate(19710.002 6589)",
    fill: "#e7387e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.96,244.21H77.65c.02-2.11.03-3.17.04-5.28h65.23C142.94,241.04,142.94,242.1,142.96,244.21Z",
    transform: "translate(19710.002 6589)",
    fill: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon1);
export default __webpack_public_path__ + "static/media/balloon-1.e5c20fe8ee40604da06b713e1fa65b98.svg";
export { ForwardRef as ReactComponent };